import {
    Component,
    Input,
    Output,
    ElementRef,
    OnChanges,
    AfterViewInit,
    SimpleChanges,
    EventEmitter
} from '@angular/core';
import { Location } from '@angular/common';

import { WindowService } from "../services/window.service";
import { ProductGroup } from "../model/product.group";
import { MainConfigurationInterface } from "../services/configuration.loader";
import { SubProduct } from "../model/subproduct";
import { PageStatePersister } from "../utils/page_state";
import { Logger } from "../utils/logger";
import { EventsService } from "../services/events.service";

import $ from 'jquery';

@Component({
    selector: 'subproduct-img',
    templateUrl: "./subproduct-image.component.html"
})
export class SubProductImage implements AfterViewInit, OnChanges {

    @Input()
    public subProduct: SubProduct;

    @Input()
    public subProductGroup: ProductGroup;

    @Input()
    public groupName: string;

    @Input()
    public width;

    @Input()
    public height;

    @Input()
    public marginLeft;

    @Output('load')
    public load: EventEmitter<{ subProduct: SubProduct, groupName: string }>;

    public zIndex: number = 0;

    constructor(public el: ElementRef, public logger: Logger, public eventBus: EventsService) {

        this.load = new EventEmitter<{ subProduct: SubProduct, groupName: string }>();
    }

    public hiddenImg: HTMLImageElement;
    public canvasImg: HTMLImageElement;

    ngAfterViewInit(): any {
        this.hiddenImg = this.el.nativeElement.querySelector('.hidden-img') as HTMLImageElement;
        this.canvasImg = this.el.nativeElement.querySelector('.canvas-img') as HTMLImageElement;
        this.hiddenImg.addEventListener('load', () => {
            $(this.canvasImg).animate({ opacity: 0 }, 1000, () => {
                $(this.canvasImg).css({ opacity: 1.0 });
            });

            $(this.hiddenImg).animate({ opacity: 1.0 }, 1000, () => {
                $(this.canvasImg).attr('src', this.hiddenImg.src);
                $(this.hiddenImg).css({ opacity: 0 });
            });

            /*
                $(this.hiddenImg).animate({opacity: 0.5}, 1000, () => {
                    $(this.canvasImg).attr('src', this.hiddenImg.src);
                    $(this.canvasImg).css({opacity: 0.5});
                    $(this.hiddenImg).css({opacity: 0});
                });
            */

            if (this.subProduct) {
                this.onLoad();
            }
        });
    }

    onLoad() {
        if (this.subProductGroup.getSubProductDepthValue) {
            this.zIndex = this.subProductGroup.getSubProductDepthValue() * 10;
        }

        this.load.emit({ subProduct: this.subProduct, groupName: this.groupName });
    }

    ngOnChanges(changes: any): any {
        if (typeof changes.subProduct !== 'undefined') {
            if (changes.subProduct.currentValue && (changes.subProduct.currentValue !== changes.subProduct.previousValue)) {
                if (this.hiddenImg) {
                    this.hiddenImg.src = changes.subProduct.currentValue.renderPath.getValue();
                }
            }
        }
    }

    getSubProductImageSrc() {
        let src: string;

        if (this.subProduct && this.subProduct.renderPath.getValue() != '') {
            src = this.subProduct.renderPath.getValue();
        } else {
            src = '';
        }

        return src;
    }
}



// WEBPACK FOOTER //
// ./src/app/canvas/subproduct-image.component.ts